<template>
  <header class="page-header">
    <section class="page-title-wrap">
      <img
        :src="logo"
        class="page-logo">
      <img
        :src="title"
        class="page-title">
    </section>
    <img
      :src="slogan"
      class="page-slogan">
  </header>
</template>
<script>
const logo = require('../../assets/logo.png')
const title = require('../../assets/title.png')
const slogan = require('../../assets/slogan.png')
export default {
  name: 'PageHeader',
  data() {
    return { logo, title, slogan }
  }
}
</script>
<style lang="stylus" scoped src="./page-header.styl"></style>
